module.exports = __webpack_public_path__ + "img/PERUGIA.fe6da980.png";